let routes = [
    // {
    //     name: 'Online Registration',
    //     icon: 'how_to_reg',
    //     path: '/online-registration',
    //     permission: 'grade-create'
    // }
];

export default routes;